<template>
  <div id="app">
      <el-container>
        <el-header class="header">
          <el-button @click="toggleMenu" class="hamburger" v-if="isLoggedIn">
            <i v-if="isCollapse" class="el-icon-s-unfold" style="font-size: 30px;"></i>
            <i v-else class="el-icon-s-fold" style="font-size: 30px;"></i>
          </el-button>
          <h4><span v-if="isLoggedIn">{{ getFabricanteNome() }}</span></h4>
          <el-dropdown v-if="isLoggedIn">
            <span class="el-dropdown-link">
              <i class="el-icon-user"></i>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown" style="width: 250px;">
              <span class="menu-link-2" style="padding-left: 20px;">{{ usuario_nome }}</span>
              <hr/>
              <el-dropdown-item>
                <a @click="editarPerfil" class="menu-link-2">Alterar Senha</a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a @click="logout" class="menu-link-2">Sair</a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-header>
      </el-container>
      <el-container class="container-principal">
        <el-menu 
          default-active="activeIndex" 
          class="menu-lateral" 
          :collapse="isCollapse"  
          background-color="#545c64"
          text-color="#fff"
          active-text-color="#ffd04b"
          v-if="isLoggedIn"
        >
        
        <el-menu-item index="0">
          <i class="el-icon-s-home"></i>
          <a href="/" class="menu-link" slot="title">Home</a>
        </el-menu-item>

        <el-submenu v-if="permissao.ler_painel" index="111">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span slot="title">Painel</span>
          </template>
          <el-menu-item v-if="permissao.ler_configuracoes" index="111-1">
            <router-link to="/orcamentos" class="menu-link" slot="title">Orçamento Painel Elétrico (Antigo)</router-link>
          </el-menu-item>
          <el-menu-item v-if="permissao.ler_painel" index="111-2">
            <router-link to="/negocio-orcamentos" class="menu-link" slot="title">Orçamento Painel Elétrico</router-link>
          </el-menu-item>
        </el-submenu>
        <el-submenu v-if="permissao.ler_termometria" index="122">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span slot="title">Termometria</span>
          </template>
          <el-menu-item v-if="permissao.ler_termometria" index="122-1">
            <router-link to="/termometria" class="menu-link">Orçamento Termometria</router-link>
          </el-menu-item>
          <el-menu-item v-if="permissao.ler_configuracoes" index="122-2">
            <router-link to="/termometria/gerencial" class="menu-link">Orçamento Termometria Gerencial</router-link>
          </el-menu-item>
<!-- 
          <el-menu-item v-if="permissao.ler_termometria" index="122-3">
            <router-link to="/termometria/produtos" class="menu-link">Produtos Termometria</router-link>
          </el-menu-item>
-->
          <el-menu-item v-if="permissao.ler_termometria" index="122-4">
            <router-link to="/termometria/cliente" class="menu-link">Clientes Finais Termometria</router-link>
          </el-menu-item>
          <el-menu-item v-if="permissao.lista_preco_termometria" index="122-5">
            <router-link to="/termometria/produto/lista" class="menu-link">Lista de Preço de Produtos Termometria</router-link>
          </el-menu-item>
          <el-menu-item v-if="permissao.manutencao_termometria" index="122-6">
            <router-link to="/termometria/manutencao" class="menu-link">Manutenção Termometria</router-link>
          </el-menu-item>
        </el-submenu>

        <el-submenu v-if="permissao.ler_configuracoes" index="133">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span slot="title">Cadastros</span>
          </template>
          <el-menu-item v-if="permissao.ler_avisos" index="133-1">
            <router-link to="/avisos" class="menu-link" slot="title">Avisos</router-link>
          </el-menu-item>
          <el-menu-item v-if="permissao.ler_user" index="133-2">
            <router-link to="/usuarios" class="menu-link">Usuários</router-link>
          </el-menu-item>
          <el-menu-item v-if="permissao.ler_contatos" index="133-3">
            <router-link to="/contatos" class="menu-link" slot="title">Contatos</router-link>
          </el-menu-item>
        </el-submenu>

<!-- 
        <el-submenu v-if="permissao.ler_configuracoes" index="155">
          <template slot="title">
            <i class="el-icon-menu"></i>
            <span slot="title">Desenvolvimento</span>
          </template>
          <el-menu-item v-if="permissao.ler_configuracoes" index="155-1">
            <router-link to="/teste" class="menu-link" slot="title">Teste 1</router-link>
          </el-menu-item>
        </el-submenu>
 -->

        <el-menu-item index="7" v-if="isLoggedIn && fabricante_qtde>1">
          <i class="el-icon-refresh"></i>
          <a @click="trocarFabricante" class="menu-link" slot="title">Alterar Fabricante</a>
        </el-menu-item>

        <el-menu-item v-if="permissao.ler_configuracoes" index="811-1">
          <i class="el-icon-setting"></i>
          <a href="/configuracoes" class="menu-link" slot="title">Configurações</a>
        </el-menu-item>

        <el-menu-item v-if="permissao.ler_configuracoes" index="811-2">
          <i class="el-icon-setting"></i>
          <a href="/configuracoes-2" class="menu-link" slot="title">Configurações 2</a> 
        </el-menu-item>

        <el-menu-item v-if="permissao.ler_configuracoes" index="811-3">
          <i class="el-icon-setting"></i>
          <a href="/configuracoes-fabricantes" class="menu-link" slot="title">Configurações Fabricantes</a>
        </el-menu-item>

        <el-menu-item v-if="permissao.ler_configuracoes" index="811-4">
          <i class="el-icon-setting"></i>
          <a href="/negocio-custo-mao-obra" class="menu-link" slot="title">Negócio Custo Mão de Obra</a>
        </el-menu-item>

        <el-menu-item index="911" v-if="isLoggedIn">
          <i class="el-icon-circle-close"></i>
          <a @click="logout" class="menu-link" slot="title">Sair</a>
        </el-menu-item>
        <el-menu-item index="912" v-else>
          <i class="el-icon-circle-plus-outline"></i>
          <router-link to="/login" class="menu-link" slot="title">Login</router-link>
        </el-menu-item>

      </el-menu>
      <el-container>
        <el-main>
          <ComponenteLoginSgeClienteFabricante ref = "fabricante"/>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>

import ComponenteLoginSgeClienteFabricante from "./components/ComponenteLoginSgeClienteFabricante.vue";
import FuncoesUteis from "./plugins/FuncoesUteis";

export default {
  name: "App",
  components: {
    ComponenteLoginSgeClienteFabricante,
  },
  data() {
    return {
      sgeCliente: 0,
      teste: "",
      src:"/static/logo.png",
      activeIndex: "1",
      nome: '',
      usuario_nome: '',
      fabricante_qtde: 0,
      permissao: [],
      isCollapse: false,
      isMobile: window.innerWidth <= 768,
    };
  },
  computed: {
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
  },
  mounted() {
    this.permissao = FuncoesUteis.isPermissao();
    // console.log("Permissões:", this.permissao);
    this.usuario_nome = localStorage.getItem('usario_nome')
    this.fabricante_qtde = localStorage.getItem("fabricante_qtde")
  },
  methods: {
    toggleMenu() {
      this.isCollapse = !this.isCollapse;
    },
    logout: function () {
      this.$store.dispatch("logout").then(() => {
        this.$router.push("/login");
      });
    },
    editarPerfil: function () {
      this.usuario = FuncoesUteis.getUsuario();
      const userId = this.usuario.id_usuario || 0;
      this.$router.push("/edituser/" + userId);
    },
    trocarFabricante() {
      this.$refs.fabricante.definirClienteSgeAdministrador()
    },
    getFabricanteNome() {
      let fabricante_nome = ""
      if (localStorage.getItem('fabricante_nome')!=null) {
        //const token = localStorage.getItem("token");
        //const payload = JSON.parse(atob(token.split(".")[1]));
        //let tipoUsuario = payload.sge_cliente || 0;
        //if (tipoUsuario==1) {
          //fabricante_nome = '('+localStorage.getItem('ultimo_fabricante')+') '+localStorage.getItem('fabricante_nome')
          fabricante_nome = localStorage.getItem('fabricante_nome')
          //console.log("Qtde Fabricante:", this.fabricante_qtde);
        //}
      }
      return fabricante_nome
    },
  },
  created: function () {
    this.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function () {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch("logout");
        }
        throw err;
      });
    });
  },

};
</script>

<style>
  body {
    margin: 0px;
    background: #f9fafc;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    overflow: hidden;
  }
  .cabecalho_impressao{
    display: none;
  }
  .el-breadcrumb {
    margin-left:10px;
  }
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 0px;
  }
  .menu-link {
    text-decoration: none;
    color: inherit;
    width: 100%;
    height: 100%;
    align-items: center;
    padding: 15px 100px 15px 0px;
    /* position: absolute; */
    /* inset: 0; */
    /* display: flex; */
    /* padding: 0 50px; */
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }
 
  .menu-link-2 {
    text-decoration: none;
    color: inherit;
    width: 100%;
    height: 100%;
    align-items: center;
    padding: 15px 80px 15px 0px;
    /* position: absolute; */
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  .el-menu--vertical {
    font-family: Avenir, Helvetica, Arial, sans-serif;
  }

  .grid-content {
    border-radius: 0px !important;
    height: 60px;
    min-height: 36px;
    background: #545c64 !important;
    color: #fff;
    font-size: 12px;
  }
  .router-link-exact-active {
    text-decoration: none;
  }
  .editar_perfil {
    text-decoration: none;
  }
  .editar_perfil:visited {
    text-decoration: none;
    color: #000;
  }
  /******************************/
  .el-dropdown-link {
    cursor: pointer;
    color: #FFF;
  }
  .el-icon-user {
    font-size: 36px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
  /******************************* */
  @media print {
    #app .el-menu-topo, #app .grid-content{
    display: none;
    }
    .cabecalho_impressao{
      display: inline;
    }
    .esconder_impressao{
      display: none;
    }
  }

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    background-color: #545c64;
    color: white;
  }

  .hamburger {
    background: none !important;
    border: none !important;
    padding: 5px !important;
    color: white !important;
    cursor: pointer;
  }

  .usuario {
    background: none !important;
    border: none !important;
    font-size: 30px !important;
    color: white !important;
    cursor: pointer;
  }

  .menu-lateral {
    text-align: left;
    overflow: auto;
  }

  .menu-lateral:not(.el-menu--collapse) {
    width: 300px;
  }

  @media (max-width: 768px) {
    .menu-lateral {
      position: absolute;
      z-index: 100;
    }
  }
  
  .container-principal {
    display: flex;
    /* flex-direction: column; */
    height: 100vh;
  }

  .item {
    margin-bottom: 0px !important;
  }

</style>
